import Login from "../../components/login/Login";

function LoginPage({ loginPageData }) {
  return <Login loginPageData={loginPageData} />;
}
export default LoginPage;
